import { render, staticRenderFns } from "./blogEditComponent.vue?vue&type=template&id=53fa5f6e&"
import script from "./blogEditComponent.vue?vue&type=script&lang=ts&"
export * from "./blogEditComponent.vue?vue&type=script&lang=ts&"
import style0 from "./blogEditComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports